import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { List } from '@mui/material';
import Box from '@mui/material/Box';

import SidebarMenuListItem from './SidebarMenuListItem';

const SidebarMenuList = (props) => {
    const { pages, ...rest } = props;
    const location = useLocation();

    return (
        <List className="p-0">
            {/* eslint-disable-next-line */}
            {pages.reduce((items, page) => reduceChildRoutes({ items, page, location, ...rest }), [])}
        </List>
    );
};

SidebarMenuList.propTypes = {
    depth: PropTypes.number.isRequired,
    pages: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

const reduceChildRoutes = (props) => {
    const { items, page, depth, location } = props;

    if (page.content) {
        const open = matchPath(location.pathname, {
            path: page.to,
            exact: false
        });
        items.push(
            <SidebarMenuListItem
                depth={depth}
                icon={page.icon}
                key={page.label}
                label={page.badge}
                open={Boolean(open)}
                title={page.label}
            >
                <Box py="12px">
                    <SidebarMenuList depth={depth + 1} pages={page.content} />
                </Box>
            </SidebarMenuListItem>
        );
    } else {
        items.push(
            <SidebarMenuListItem
                depth={depth}
                href={page.to}
                icon={page.icon}
                key={page.label}
                label={page.badge}
                title={page.label}
            />
        );
    }

    return items;
};

const SidebarMenu = (props) => {
    const { pages, className, component: Component, ...rest } = props;
    return (
        // eslint-disable-next-line
        <Component {...rest} className={className}>
            <SidebarMenuList depth={0} pages={pages} />
        </Component>
    );
};

SidebarMenu.defaultProps = {
    className: 'div'
};
SidebarMenu.propTypes = {
    className: PropTypes.string,
    component: PropTypes.elementType,
    pages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    title: PropTypes.string
};

SidebarMenu.defaultProps = {
    component: 'nav'
};

export default SidebarMenu;
